<script>
  export let as = 'h1';
  export let className = '';
  export let letterSpacing = '';
  export let fontSize = '';
  export let lineHeight = '';
  export let textAlign = '';
  export let color = '';
  export let fontWeight = '';

  const style = `
    ${fontSize ? `font-size: ${fontSize};` : ''}
    ${lineHeight ? `line-height: ${lineHeight};` : ''}
    ${letterSpacing ? `letter-spacing: ${letterSpacing};` : ''}
    ${textAlign ? `text-align: ${textAlign};` : ''}
    ${color ? `color: ${color};` : ''}
    ${fontWeight ? `font-weight: ${fontWeight};` : ''}
  `;
</script>

{#if as === 'h1'}
  <h1 class={className} {style}><slot /></h1>
{/if}
{#if as === 'h2'}
  <h2 class={className} {style}><slot /></h2>
{/if}
{#if as === 'h3'}
  <h3 class={className} {style}><slot /></h3>
{/if}
{#if as === 'h4'}
  <h4 class={className} {style}><slot /></h4>
{/if}

<style lang="scss">
  h1,
  h2,
  h3,
  h4 {
    color: $color-black;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    outline: none !important;
    margin: 0 !important;
    text-transform: none;
  }
  h1 {
    font-size: 1.8em;
    line-height: 25px;
    font-weight: 600;
  }
  h2 {
    font-size: 1.6em;
  }
  h3 {
    font-size: 1.3em;
  }
  h4 {
    font-size: 14px;
  }
</style>
